import { render } from "./overall-level.vue?vue&type=template&id=65d27797&scoped=true&ts=true"
import script from "./overall-level.vue?vue&type=script&lang=ts"
export * from "./overall-level.vue?vue&type=script&lang=ts"

import "./overall-level.vue?vue&type=style&index=0&id=65d27797&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d27797"]])

export default __exports__